export default {"src":"/login-app/[GIT_HASH]/_next/static/media/key_shift.5342b24f.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};